export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
}

export interface AcceptOffer {
  loyalty_status: Scalars['Boolean']['input'];
  message: InputMaybe<Scalars['String']['input']>;
  offer_id: Scalars['ID']['input'];
  offer_participant_percentage: Scalars['Float']['input'];
  offer_published_id: Scalars['ID']['input'];
  policy_number: Scalars['String']['input'];
  published_by: InputMaybe<Scalars['String']['input']>;
}

export interface Attachment {
  __typename?: 'Attachment';
  file_name: Scalars['String']['output'];
  file_path: Scalars['String']['output'];
  file_size: Maybe<Scalars['Int']['output']>;
  file_url: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mime_type: Maybe<Scalars['String']['output']>;
  uploaded_at: Maybe<Scalars['String']['output']>;
}

export interface AuditTrailInput {
  published_offer_id: Scalars['ID']['input'];
}

export interface AuthConfig {
  __typename?: 'AuthConfig';
  has_disabled_otp_before: Maybe<AuthOptions>;
  otp_enabled: Maybe<AuthOptions>;
}

export enum AuthOptions {
  No = 'NO',
  Yes = 'YES'
}

export interface AuthPayload {
  __typename?: 'AuthPayload';
  access_token: Maybe<Scalars['String']['output']>;
  expires_in: Maybe<Scalars['Int']['output']>;
  refresh_token: Maybe<Scalars['String']['output']>;
  token_type: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
}

export enum BrokerTypes {
  Irisk = 'IRISK',
  Kek = 'KEK',
  Placeit = 'PLACEIT',
  Visal = 'VISAL'
}

export interface CancelledOfferFilters {
  approval_status: InputMaybe<Status_Type>;
  claim_status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  class_of_business_id: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  expiry_status: InputMaybe<Scalars['String']['input']>;
  insurer_id: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offer_from: InputMaybe<Scalars['String']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  payment_status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payment_type: InputMaybe<Scalars['String']['input']>;
  published_by: InputMaybe<Scalars['String']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  staff_id: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year: InputMaybe<Scalars['String']['input']>;
}

export interface ClaimAttachmentsData {
  __typename?: 'ClaimAttachmentsData';
  attachments: Maybe<Array<Maybe<Attachment>>>;
  claim_id: Maybe<Scalars['ID']['output']>;
}

export interface ClaimAttachmentsResponse {
  __typename?: 'ClaimAttachmentsResponse';
  data: Maybe<ClaimAttachmentsData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface ClaimData {
  __typename?: 'ClaimData';
  claim_amount: Maybe<Scalars['Float']['output']>;
  claim_comment: Maybe<Scalars['String']['output']>;
  claim_date: Maybe<Scalars['String']['output']>;
  claim_share_percentage: Maybe<Scalars['Float']['output']>;
  created_at: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  offer: Maybe<Offer>;
  offer_claim_id: Maybe<Scalars['ID']['output']>;
  offer_id: Maybe<Scalars['ID']['output']>;
  rate: Maybe<Scalars['Float']['output']>;
}

export interface ClaimReport {
  __typename?: 'ClaimReport';
  data: Maybe<Array<Maybe<ClaimReportData>>>;
  error: Maybe<ErrorMsg>;
  name: Maybe<Scalars['String']['output']>;
}

export interface ClaimReportData {
  __typename?: 'ClaimReportData';
  cedant: Maybe<Scalars['String']['output']>;
  claim_share: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  insured: Maybe<Scalars['String']['output']>;
  period_from: Maybe<Scalars['String']['output']>;
  period_to: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
}

export interface ClaimThreadData {
  __typename?: 'ClaimThreadData';
  claim_id: Maybe<Scalars['ID']['output']>;
  messages: Maybe<Array<Maybe<Message>>>;
  subject: Maybe<Scalars['String']['output']>;
  thread_id: Maybe<Scalars['ID']['output']>;
}

export interface ClaimThreadResponse {
  __typename?: 'ClaimThreadResponse';
  data: Maybe<ClaimThreadData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface ClassOfBusiness {
  __typename?: 'ClassOfBusiness';
  business_category: Maybe<Scalars['String']['output']>;
  business_details: Maybe<Scalars['String']['output']>;
  business_name: Scalars['String']['output'];
  class_of_business_id: Maybe<Scalars['ID']['output']>;
  created_at: Maybe<Scalars['String']['output']>;
  delete_status: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['String']['output']>;
}

export interface ClientActivity {
  __typename?: 'ClientActivity';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  country_code: Maybe<Scalars['String']['output']>;
  device_type: Maybe<Scalars['String']['output']>;
  ip_address: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  resource_accessed: Maybe<Scalars['String']['output']>;
}

export interface DeleteAttachmentData {
  __typename?: 'DeleteAttachmentData';
  attachment_id: Scalars['ID']['output'];
}

export interface DeleteAttachmentResponse {
  __typename?: 'DeleteAttachmentResponse';
  data: Maybe<DeleteAttachmentData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface DisableOtp {
  email: Scalars['String']['input'];
}

export interface DisableOtpInput {
  email: Scalars['String']['input'];
}

export interface DisableOtpResponse {
  __typename?: 'DisableOtpResponse';
  is_first_time_disable: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface Employee {
  __typename?: 'Employee';
  emp_abbrv: Maybe<Scalars['String']['output']>;
  employee_email: Scalars['String']['output'];
  employee_first_name: Scalars['String']['output'];
  employee_id: Scalars['ID']['output'];
  employee_last_name: Scalars['String']['output'];
  employee_phonenumber: Scalars['String']['output'];
  log_activities: Maybe<Array<Maybe<Log_Activity>>>;
  total_offers: Maybe<Array<Maybe<Offer>>>;
  user: User;
}

export interface EnableOtpInput {
  email: Scalars['String']['input'];
}

export interface EnableOtpResponse {
  __typename?: 'EnableOtpResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
}

export interface ErrorMsg {
  __typename?: 'ErrorMsg';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
}

export interface ErrorResponse {
  __typename?: 'ErrorResponse';
  error: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
}

export interface EstimatedRiValues {
  __typename?: 'EstimatedRIValues';
  currency: Maybe<Scalars['String']['output']>;
  total_facultative_premium: Maybe<Scalars['Float']['output']>;
}

export interface ForgotPasswordInput {
  email: Scalars['String']['input'];
}

export interface ForgotPasswordResponse {
  __typename?: 'ForgotPasswordResponse';
  message: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface HoldKavaDecision {
  decision: InputMaybe<HoldKavaDecisionEnum>;
  offer_id: InputMaybe<Scalars['ID']['input']>;
  published_by: InputMaybe<Scalars['String']['input']>;
}

export enum HoldKavaDecisionEnum {
  Accept = 'ACCEPT',
  Decline = 'DECLINE'
}

export interface HoldKavaOffers {
  __typename?: 'HoldKavaOffers';
  offer: Maybe<Offer>;
}

export interface HoldKavaOffersInput {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  published_by: InputMaybe<Scalars['String']['input']>;
}

export interface HoldKavaParticipant {
  __typename?: 'HoldKavaParticipant';
  created_at: Maybe<Scalars['String']['output']>;
  decision: Maybe<HoldKavaResponseDecision>;
  id: Maybe<Scalars['ID']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  reinsurer_representative_id: Maybe<Scalars['ID']['output']>;
  reinsurersreinsurer_id: Maybe<Scalars['ID']['output']>;
  updated_at: Maybe<Scalars['String']['output']>;
}

export enum HoldKavaResponseDecision {
  Accept = 'ACCEPT',
  Decline = 'DECLINE'
}

export interface Insurer {
  __typename?: 'Insurer';
  insurer_address: Maybe<Insurer_Address>;
  insurer_company_email: Maybe<Scalars['String']['output']>;
  insurer_company_name: Maybe<Scalars['String']['output']>;
  insurer_id: Maybe<Scalars['ID']['output']>;
}

export interface Insurer_Address {
  __typename?: 'Insurer_address';
  country: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
}

export interface Insurer_Associate {
  __typename?: 'Insurer_associate';
  assoc_email: Maybe<Scalars['String']['output']>;
  assoc_first_name: Maybe<Scalars['String']['output']>;
  assoc_last_name: Maybe<Scalars['String']['output']>;
  assoc_primary_phonenumber: Maybe<Scalars['String']['output']>;
  assoc_secondary_phonenumber: Maybe<Scalars['String']['output']>;
  insurer: Maybe<Insurer>;
  position: Maybe<Scalars['String']['output']>;
}

export interface Log_Activity {
  __typename?: 'Log_activity';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  device_ip: Maybe<Scalars['String']['output']>;
  device_type: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
}

export interface LoginInput {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}

export interface LoginPassword {
  confirm_password: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface LogoutResponse {
  __typename?: 'LogoutResponse';
  message: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface LoyalPoints {
  __typename?: 'LoyalPoints';
  total_loyalty_points: Maybe<Scalars['Int']['output']>;
  total_redeemable_loyalty_points: Maybe<Scalars['Int']['output']>;
}

export interface MarkMessageData {
  __typename?: 'MarkMessageData';
  message_id: Maybe<Scalars['ID']['output']>;
}

export interface MarkMessageResponse {
  __typename?: 'MarkMessageResponse';
  data: Maybe<MarkMessageData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface MarkThreadData {
  __typename?: 'MarkThreadData';
  claim_id: Maybe<Scalars['ID']['output']>;
  thread_id: Maybe<Scalars['ID']['output']>;
}

export interface MarkThreadResponse {
  __typename?: 'MarkThreadResponse';
  data: Maybe<MarkThreadData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface MarketGrowthValues {
  __typename?: 'MarketGrowthValues';
  currency: Maybe<Scalars['String']['output']>;
  market_growth: Maybe<Scalars['Float']['output']>;
  today_total: Maybe<Scalars['Float']['output']>;
  yesterday_total: Maybe<Scalars['Float']['output']>;
}

export interface Message {
  __typename?: 'Message';
  body: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_internal: Scalars['Boolean']['output'];
  is_read: Scalars['Boolean']['output'];
  sender_id: Maybe<Scalars['ID']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
}

export interface MockAccountId {
  __typename?: 'MockAccountID';
  account_periods: Maybe<Scalars['String']['output']>;
  treaty_account_id: Maybe<Scalars['ID']['output']>;
}

export interface MockInsurerStruct {
  __typename?: 'MockInsurerStruct';
  insurer_company_name: Maybe<Scalars['String']['output']>;
  insurer_id: Maybe<Scalars['ID']['output']>;
}

export interface MockLayerLimit {
  __typename?: 'MockLayerLimit';
  installment_type: Maybe<Scalars['String']['output']>;
  limit: Maybe<Scalars['String']['output']>;
  m_and_d_premium: Maybe<Scalars['Float']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
}

export interface MockOffer {
  __typename?: 'MockOffer';
  classofbusiness: Maybe<ClassOfBusiness>;
  expiry_status: Maybe<Scalars['String']['output']>;
  facultative_offer: Maybe<Scalars['Float']['output']>;
  insurance_company_name: Maybe<Scalars['String']['output']>;
  insurer: Maybe<MockInsurerStruct>;
  insurersinsurer_id: Maybe<Scalars['ID']['output']>;
  offer_claim: Maybe<Array<Maybe<MockOfferClaimStruct>>>;
  offer_from: Maybe<Scalars['String']['output']>;
  offer_id: Maybe<Scalars['ID']['output']>;
  offer_published: Maybe<MockOfferPublishedStruct>;
  offer_published_participants: Maybe<Array<Maybe<MockOfferPublishedParticipantStruct>>>;
  payment_status: Maybe<MockPaymentStatus>;
  place_it_id: Maybe<Scalars['ID']['output']>;
  unread_messages: Maybe<Array<Maybe<UnreadTransactionThread>>>;
  unread_transaction_thread: Maybe<Array<Maybe<MockUnreadTransactionThreadStruct>>>;
  unread_transaction_threads: Maybe<Array<Maybe<UnreadTransactionThread>>>;
}

export interface MockOfferClaimParticipantStruct {
  __typename?: 'MockOfferClaimParticipantStruct';
  claim_share: Maybe<Scalars['Float']['output']>;
  offer_claim_participant_id: Maybe<Scalars['ID']['output']>;
  offer_participant_id: Maybe<Scalars['ID']['output']>;
}

export interface MockOfferClaimStruct {
  __typename?: 'MockOfferClaimStruct';
  claim_amount: Maybe<Scalars['Float']['output']>;
  claim_date: Maybe<Scalars['String']['output']>;
  offer_claim_id: Maybe<Scalars['ID']['output']>;
  offer_claim_participants: Maybe<Array<Maybe<MockOfferClaimParticipantStruct>>>;
}

export interface MockOfferDeduction {
  __typename?: 'MockOfferDeduction';
  brokerage: Maybe<Scalars['Float']['output']>;
  brokerage_amount: Maybe<Scalars['Float']['output']>;
  commission: Maybe<Scalars['Float']['output']>;
  commission_amount: Maybe<Scalars['Float']['output']>;
  nic_levy: Maybe<Scalars['Float']['output']>;
  nic_levy_amount: Maybe<Scalars['Float']['output']>;
  withholding_tax: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount: Maybe<Scalars['Float']['output']>;
}

export interface MockOfferDetail {
  __typename?: 'MockOfferDetail';
  currency: Maybe<Scalars['String']['output']>;
  insured_by: Maybe<Scalars['String']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  period_of_insurance_from: Maybe<Scalars['String']['output']>;
  period_of_insurance_to: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
}

export interface MockOfferPublishedParticipantStruct {
  __typename?: 'MockOfferPublishedParticipantStruct';
  offer_participant_percentage: Maybe<Scalars['Float']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  participation_status: Maybe<Scalars['String']['output']>;
  reinsurersreinsurer_id: Maybe<Scalars['ID']['output']>;
}

export interface MockOfferPublishedStruct {
  __typename?: 'MockOfferPublishedStruct';
  created_at: Maybe<Scalars['String']['output']>;
  employeesemployee_id: Maybe<Scalars['ID']['output']>;
  offer_published_id: Maybe<Scalars['ID']['output']>;
  offer_published_participant: Maybe<OfferPublishedParticipant>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  published_status: Maybe<Scalars['String']['output']>;
  time_of_expiry: Maybe<Scalars['String']['output']>;
}

export interface MockOfferStruct {
  __typename?: 'MockOfferStruct';
  offer: Maybe<MockOffer>;
  offer_amount: Maybe<Scalars['Float']['output']>;
  offer_detail: Maybe<MockOfferDetail>;
  offer_extra_charges: Maybe<MockOfferDeduction>;
  offer_participant_id: Maybe<Scalars['ID']['output']>;
  offer_participant_payment: Maybe<Array<Maybe<MockPaymentStruct>>>;
  offer_participant_percentage: Maybe<Scalars['Float']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  participant_fac_premium: Maybe<Scalars['Float']['output']>;
  participant_fac_sum_insured: Maybe<Scalars['Float']['output']>;
  reinsurer: Maybe<Reinsurer>;
  unread_transaction_thread: Maybe<Array<Maybe<UnreadTransaction>>>;
}

export enum MockPaymentStatus {
  Paid = 'PAID',
  Partpayment = 'PARTPAYMENT',
  Unpaid = 'UNPAID'
}

export interface MockPaymentStruct {
  __typename?: 'MockPaymentStruct';
  created_at: Maybe<Scalars['String']['output']>;
  date_of_distribution: Maybe<Scalars['String']['output']>;
  offer_payment_amount: Maybe<Scalars['Float']['output']>;
  paid_details: Maybe<Scalars['String']['output']>;
}

export interface MockTreatyDeductionStruct {
  __typename?: 'MockTreatyDeductionStruct';
  treaty_period_from: Maybe<Scalars['String']['output']>;
  treaty_period_to: Maybe<Scalars['String']['output']>;
}

export interface MockTreatyProgramStruct {
  __typename?: 'MockTreatyProgramStruct';
  treaty_name: Maybe<Scalars['String']['output']>;
  treaty_program_id: Maybe<Scalars['Int']['output']>;
  treaty_type: Maybe<Scalars['String']['output']>;
}

export interface MockTreatyStruct {
  __typename?: 'MockTreatyStruct';
  currency: Maybe<Scalars['String']['output']>;
  insurer: Maybe<MockInsurerStruct>;
  layer_limit: Maybe<Scalars['String']['output']>;
  order_hereon: Maybe<Scalars['Float']['output']>;
  treaty_accounts: Maybe<Array<Maybe<MockAccountId>>>;
  treaty_deduction: Maybe<MockTreatyDeductionStruct>;
  treaty_id: Maybe<Scalars['ID']['output']>;
  treaty_participation_percentage: Maybe<Scalars['Float']['output']>;
  treaty_program: Maybe<MockTreatyProgramStruct>;
  treaty_reference: Maybe<Scalars['String']['output']>;
}

export enum MockTreatyType {
  Nonproportional = 'NONPROPORTIONAL',
  Proportional = 'PROPORTIONAL'
}

export interface MockUnreadTransactionThreadStruct {
  __typename?: 'MockUnreadTransactionThreadStruct';
  broker_id: Maybe<Scalars['ID']['output']>;
  created_at: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  offer_id: Maybe<Scalars['ID']['output']>;
  offer_published_id: Maybe<Scalars['ID']['output']>;
  offer_published_participant_id: Maybe<Scalars['ID']['output']>;
  receivable_id: Maybe<Scalars['ID']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptOffer: Scalars['Boolean']['output'];
  deleteClaimAttachment: Maybe<DeleteAttachmentResponse>;
  disableOTPAuthentication: DisableOtpResponse;
  enableOTPAuthentication: EnableOtpResponse;
  forgotPassword: ForgotPasswordResponse;
  forgottenPassword: ForgotPasswordResponse;
  generateClaimsReport: Maybe<Array<Maybe<ClaimReport>>>;
  generateOtp: OtpResponse;
  generatePaymentReport: Maybe<Array<Maybe<PaymentReport>>>;
  generateRevenueReport: Maybe<Array<Maybe<RevenueReport>>>;
  holdKavaDecision: Maybe<Scalars['Boolean']['output']>;
  issueGuaranteeNote: Maybe<Scalars['String']['output']>;
  logActivity: Maybe<Scalars['Boolean']['output']>;
  login: AuthPayload;
  logout: LogoutResponse;
  markMessageRead: Maybe<MarkMessageResponse>;
  markMessageUnread: Maybe<MarkMessageResponse>;
  markThreadRead: Maybe<MarkThreadResponse>;
  postClaimMessage: Maybe<PostMessageResponse>;
  readTransactionThread: Maybe<Scalars['Boolean']['output']>;
  refreshToken: RefreshTokenPayload;
  register: RegisterResponse;
  resetPassword: ResetPasswordResponse;
  sendMessageOnOffer: Maybe<Scalars['Boolean']['output']>;
  sendOfferParticipationMessage: Maybe<Scalars['Boolean']['output']>;
  setLoginPassword: Maybe<Scalars['Boolean']['output']>;
  socialLogin: AuthPayload;
  updateForgottenPassword: ForgotPasswordResponse;
  updateOfferParticipationPercentage: Maybe<Scalars['Boolean']['output']>;
  updatePassword: UpdatePasswordResponse;
  updateTermsOfService: Maybe<Scalars['Boolean']['output']>;
  uploadClaimAttachments: Maybe<ClaimAttachmentsResponse>;
  validateOtp: OtpValidationResponse;
  verifyEmail: AuthPayload;
  withdrawOfferParticipation: Maybe<Scalars['Boolean']['output']>;
}


export interface MutationAcceptOfferArgs {
  input: AcceptOffer;
}


export interface MutationDeleteClaimAttachmentArgs {
  attachment_id: Scalars['ID']['input'];
}


export interface MutationDisableOtpAuthenticationArgs {
  input: DisableOtpInput;
}


export interface MutationEnableOtpAuthenticationArgs {
  input: EnableOtpInput;
}


export interface MutationForgotPasswordArgs {
  input: ForgotPasswordInput;
}


export interface MutationForgottenPasswordArgs {
  input: ForgotPasswordInput;
}


export interface MutationGenerateClaimsReportArgs {
  args: InputMaybe<ReportInput>;
}


export interface MutationGenerateOtpArgs {
  args: InputMaybe<OtpInput>;
}


export interface MutationGeneratePaymentReportArgs {
  args: InputMaybe<ReportInput>;
}


export interface MutationGenerateRevenueReportArgs {
  args: InputMaybe<ReportInput>;
}


export interface MutationHoldKavaDecisionArgs {
  input: HoldKavaDecision;
}


export interface MutationIssueGuaranteeNoteArgs {
  broker: BrokerTypes;
}


export interface MutationLoginArgs {
  input: InputMaybe<LoginInput>;
}


export interface MutationMarkMessageReadArgs {
  message_id: Scalars['ID']['input'];
}


export interface MutationMarkMessageUnreadArgs {
  message_id: Scalars['ID']['input'];
}


export interface MutationMarkThreadReadArgs {
  claim_id: Scalars['ID']['input'];
  reinsurer_id: Scalars['ID']['input'];
}


export interface MutationPostClaimMessageArgs {
  body: Scalars['String']['input'];
  claim_id: Scalars['ID']['input'];
  is_internal: InputMaybe<Scalars['Boolean']['input']>;
  reinsurer_id: Scalars['ID']['input'];
  subject: InputMaybe<Scalars['String']['input']>;
}


export interface MutationReadTransactionThreadArgs {
  input: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  published_by: InputMaybe<Scalars['String']['input']>;
}


export interface MutationRefreshTokenArgs {
  input: InputMaybe<RefreshTokenInput>;
}


export interface MutationRegisterArgs {
  input: InputMaybe<RegisterInput>;
}


export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}


export interface MutationSendMessageOnOfferArgs {
  input: SendMessageOnOffer;
}


export interface MutationSendOfferParticipationMessageArgs {
  input: SendOfferParticipationMessage;
}


export interface MutationSetLoginPasswordArgs {
  input: InputMaybe<LoginPassword>;
}


export interface MutationSocialLoginArgs {
  input: SocialLoginInput;
}


export interface MutationUpdateForgottenPasswordArgs {
  input: InputMaybe<NewPasswordWithCodeInput>;
}


export interface MutationUpdateOfferParticipationPercentageArgs {
  input: InputMaybe<UpdateOfferParticipationPercentage>;
}


export interface MutationUpdatePasswordArgs {
  input: UpdatePassword;
}


export interface MutationUpdateTermsOfServiceArgs {
  args: InputMaybe<TermsOfServiceInput>;
}


export interface MutationUploadClaimAttachmentsArgs {
  attachments: Array<Scalars['String']['input']>;
  claim_id: Scalars['ID']['input'];
}


export interface MutationValidateOtpArgs {
  args: InputMaybe<OtpValidationInput>;
}


export interface MutationVerifyEmailArgs {
  input: VerifyEmailInput;
}


export interface MutationWithdrawOfferParticipationArgs {
  input: InputMaybe<WithdrawOfferParticipation>;
}

export interface NewPasswordWithCodeInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface Offer {
  __typename?: 'Offer';
  brokerage: Maybe<Scalars['Int']['output']>;
  class_of_business: Maybe<ClassOfBusiness>;
  classofbusiness: Maybe<ClassOfBusiness>;
  closed_date: Maybe<Scalars['String']['output']>;
  commission: Maybe<Scalars['Float']['output']>;
  commission_amount: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['String']['output']>;
  delete_status: Maybe<Scalars['String']['output']>;
  employeesemployee_id: Scalars['ID']['output'];
  expiry_status: Maybe<Scalars['String']['output']>;
  fac_premium: Maybe<Scalars['String']['output']>;
  fac_sum_insured: Maybe<Scalars['String']['output']>;
  facultative_offer: Maybe<Scalars['Float']['output']>;
  hold_kava_participant: Maybe<HoldKavaParticipant>;
  id: Maybe<Scalars['ID']['output']>;
  insurer: Maybe<Insurer>;
  insurersinsurer_id: Scalars['ID']['output'];
  offer_cancel_reason: Maybe<Scalars['String']['output']>;
  offer_detail: Maybe<OfferDetail>;
  offer_drawer: Maybe<Scalars['String']['output']>;
  offer_from: Maybe<Scalars['String']['output']>;
  offer_id: Maybe<Scalars['ID']['output']>;
  offer_published: Maybe<OfferPublished>;
  offer_status: Maybe<Scalars['String']['output']>;
  place_it_id: Maybe<Scalars['Int']['output']>;
  premium: Maybe<Scalars['String']['output']>;
  rate: Maybe<Scalars['Float']['output']>;
  sum_insured: Maybe<Scalars['Float']['output']>;
  transaction_thread: Maybe<Array<Maybe<TransactionThread>>>;
  unread_transaction_threads: Maybe<Array<Maybe<UnreadTransactionThread>>>;
  updated_at: Maybe<Scalars['String']['output']>;
}

export interface OfferDetail {
  __typename?: 'OfferDetail';
  currency: Maybe<Scalars['String']['output']>;
  insured_by: Maybe<Scalars['String']['output']>;
  offer_comment: Maybe<Scalars['String']['output']>;
  offer_detail_id: Maybe<Scalars['ID']['output']>;
  offer_details: Maybe<Scalars['String']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  period_of_insurance_from: Maybe<Scalars['String']['output']>;
  period_of_insurance_to: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
}

export interface OfferMessages {
  __typename?: 'OfferMessages';
  is_condition: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['String']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
}

export interface OfferMessagesInput {
  offer_id: InputMaybe<Scalars['ID']['input']>;
}

export interface OfferPaginatedResponse {
  __typename?: 'OfferPaginatedResponse';
  current_page: Maybe<Scalars['Int']['output']>;
  data: Maybe<Array<Maybe<MockOfferStruct>>>;
  first_page_url: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['Int']['output']>;
  last_page: Maybe<Scalars['Int']['output']>;
  per_page: Maybe<Scalars['Int']['output']>;
  to: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
}

export interface OfferPayment {
  __typename?: 'OfferPayment';
  created_at: Maybe<Scalars['String']['output']>;
  delete_status: Maybe<Scalars['String']['output']>;
  distribute_payment: Maybe<Scalars['Boolean']['output']>;
  offer_payment_comment: Maybe<Scalars['String']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  payment_amount: Maybe<Scalars['Float']['output']>;
  payment_details: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['String']['output']>;
}

export interface OfferPublished {
  __typename?: 'OfferPublished';
  created_at: Scalars['String']['output'];
  employee: Maybe<Employee>;
  employeesemployee_id: Maybe<Scalars['Int']['output']>;
  insurerassociates_insurer_associate_id: Maybe<Scalars['Int']['output']>;
  is_upcoming_renewal: Maybe<Scalars['Boolean']['output']>;
  offer: Offer;
  offer_published_id: Scalars['ID']['output'];
  participated_by: Maybe<Scalars['String']['output']>;
  published_by: Maybe<Scalars['String']['output']>;
  published_status: PublishedStatus;
  reinsurer_participation: Maybe<ReinsurersParticipation>;
  status: Scalars['String']['output'];
  time_of_expiry: Scalars['String']['output'];
  unread_messages: Maybe<Array<Maybe<UnreadMessages>>>;
  updated_at: Scalars['String']['output'];
  updated_by: Maybe<Scalars['Int']['output']>;
}

export interface OfferPublishedParticipant {
  __typename?: 'OfferPublishedParticipant';
  offer_participant_percentage: Maybe<Scalars['Float']['output']>;
  offer_published_participant_id: Maybe<Scalars['ID']['output']>;
  offersoffer_id: Maybe<Scalars['ID']['output']>;
  participation_status: Maybe<Scalars['String']['output']>;
  reinsurersreinsurer_id: Maybe<Scalars['ID']['output']>;
}

export interface OfferRequest {
  broker: Scalars['String']['input'];
}

export type OfferResponse = ErrorResponse | OfferResponseData;

export interface OfferResponseData {
  __typename?: 'OfferResponseData';
  offers: Maybe<Array<Maybe<MockOfferStruct>>>;
  total_offers: Maybe<Scalars['Int']['output']>;
  total_shares: Maybe<Scalars['String']['output']>;
}

export enum OfferStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export interface OfferSummaryCount {
  __typename?: 'OfferSummaryCount';
  missed_offers: Maybe<Scalars['Int']['output']>;
  todays_offers: Maybe<Scalars['Int']['output']>;
}

export interface OffersParticipation {
  __typename?: 'OffersParticipation';
  created_at: Maybe<Scalars['String']['output']>;
  delete_status: Maybe<Scalars['String']['output']>;
  offer: Maybe<Offer>;
  offer_participant_percentage: Maybe<Scalars['Float']['output']>;
  offer_published_participant_id: Scalars['ID']['output'];
  offersoffer_id: Scalars['ID']['output'];
  participation_status: Maybe<Scalars['String']['output']>;
  reinsurer_representativesreinsurer_representative_id: Scalars['ID']['output'];
  reinsurersreinsurer_id: Scalars['ID']['output'];
  updated_at: Maybe<Scalars['String']['output']>;
}

/** Allows ordering a list of records. */
export interface OrderByClause {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export interface OtpInput {
  identifier: Scalars['String']['input'];
}

export interface OtpResponse {
  __typename?: 'OtpResponse';
  message: Maybe<Scalars['String']['output']>;
  otp: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface OtpValidationInput {
  identifier: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}

export interface OtpValidationResponse {
  __typename?: 'OtpValidationResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

/** Information about pagination using a Relay style cursor connection. */
export interface PageInfo {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
}

/** Information about pagination using a fully featured paginator. */
export interface PaginatorInfo {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
}

export interface PaymentReport {
  __typename?: 'PaymentReport';
  data: Maybe<Array<Maybe<PaymentReportData>>>;
  error: Maybe<ErrorMsg>;
  name: Maybe<Scalars['String']['output']>;
}

export interface PaymentReportData {
  __typename?: 'PaymentReportData';
  cedant: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  insured: Maybe<Scalars['String']['output']>;
  payment_amount: Maybe<Scalars['String']['output']>;
  payment_type: Maybe<Scalars['String']['output']>;
  period_from: Maybe<Scalars['String']['output']>;
  period_to: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
}

export interface PostMessageData {
  __typename?: 'PostMessageData';
  message: Maybe<Message>;
  thread_id: Maybe<Scalars['ID']['output']>;
}

export interface PostMessageResponse {
  __typename?: 'PostMessageResponse';
  data: Maybe<PostMessageData>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface PublishedOfferAuditTrail {
  __typename?: 'PublishedOfferAuditTrail';
  action: Maybe<Scalars['String']['output']>;
  actor: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['String']['output']>;
}

export enum PublishedStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

/** Indicates what fields are available at the top level of a query operation. */
export interface Query {
  __typename?: 'Query';
  fetchEstimatedRIValues: Maybe<Array<Maybe<EstimatedRiValues>>>;
  fetchHoldKavaOffers: Maybe<Array<Maybe<Offer>>>;
  fetchMarketGrowth: Maybe<Array<Maybe<MarketGrowthValues>>>;
  fetchOfferParticipationTransactionThread: Maybe<Array<Maybe<TransactionThread>>>;
  fetchOfferSummaryCount: Maybe<OfferSummaryCount>;
  fetchOffers: Maybe<OfferPaginatedResponse>;
  fetchOffersParticipating: Maybe<Array<Maybe<OffersParticipation>>>;
  fetchPublishedOfferAuditTrail: Maybe<Array<Maybe<PublishedOfferAuditTrail>>>;
  fetchReinsurerAverageOfferAcceptanceRate: Maybe<ReinsurerAverageOfferAcceptanceRate>;
  fetchReinsurerRepresentativeLoyaltyPoints: Maybe<LoyalPoints>;
  fetchReinsurerShare: Maybe<Array<Maybe<EstimatedRiValues>>>;
  fetchRenewalRIValue: Maybe<Scalars['Int']['output']>;
  fetchTreaties: Maybe<TreatyPaginatedResponse>;
  fetchUnreadTransactionThreadMessagesForReinsurer: Maybe<Array<Maybe<UnreadTransactionThread>>>;
  fetchUpcomingRenewals: Maybe<Scalars['Int']['output']>;
  getCancelledOffers: Maybe<Array<Maybe<Offer>>>;
  getClaimThread: Maybe<ClaimThreadResponse>;
  getClaims: Maybe<Array<Maybe<ClaimData>>>;
  getOfferMessages: Maybe<Array<Maybe<OfferMessages>>>;
  getOfferPayments: Maybe<Array<Maybe<OfferPayment>>>;
  getPublishedOffers: Array<OfferPublished>;
  getSingleClaim: Maybe<ClaimData>;
  listClaimAttachments: Maybe<ClaimAttachmentsResponse>;
  loadDashboardSummaries: Maybe<Scalars['String']['output']>;
  revenueReportApi: Maybe<Array<Maybe<RevenueReportPayload>>>;
  revenueReportClassofBusiness: Maybe<Array<Maybe<RevenueByClassOfBusinessResponse>>>;
  seeClientActivites: Maybe<Array<Maybe<UserActivities>>>;
  /** Find a single user by an identifying attribute. */
  user: Maybe<User>;
  /** List multiple users. */
  users: Maybe<UserPaginator>;
  viewClaimAttachment: Maybe<ViewAttachmentResponse>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchHoldKavaOffersArgs {
  input: InputMaybe<HoldKavaOffersInput>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchOfferParticipationTransactionThreadArgs {
  offer_published_participant: Scalars['ID']['input'];
  published_by: InputMaybe<Scalars['String']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchOfferSummaryCountArgs {
  reinsurer_id: Scalars['Int']['input'];
  search_term: InputMaybe<Scalars['String']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchOffersArgs {
  broker: BrokerTypes;
  offer_status: InputMaybe<Scalars['String']['input']>;
  paginateTo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchItem?: InputMaybe<Scalars['String']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchOffersParticipatingArgs {
  offer_status: InputMaybe<Scalars['String']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchPublishedOfferAuditTrailArgs {
  input: InputMaybe<AuditTrailInput>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchReinsurerAverageOfferAcceptanceRateArgs {
  period?: InputMaybe<Scalars['Int']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryFetchTreatiesArgs {
  broker: BrokerTypes;
  paginateTo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchItem?: InputMaybe<Scalars['String']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetCancelledOffersArgs {
  filters: InputMaybe<CancelledOfferFilters>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetClaimThreadArgs {
  claim_id: InputMaybe<Scalars['ID']['input']>;
  reinsurer_id: InputMaybe<Scalars['ID']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetClaimsArgs {
  currency: InputMaybe<Scalars['String']['input']>;
  date_from: InputMaybe<Scalars['String']['input']>;
  date_to: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offer_id: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetOfferMessagesArgs {
  input: InputMaybe<OfferMessagesInput>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetOfferPaymentsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offer_id: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetPublishedOffersArgs {
  OfferStatus: InputMaybe<Scalars['String']['input']>;
  filter_status: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  published_by: InputMaybe<Scalars['String']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryGetSingleClaimArgs {
  claim_id: Scalars['ID']['input'];
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryListClaimAttachmentsArgs {
  claim_id: Scalars['ID']['input'];
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryRevenueReportApiArgs {
  args: InputMaybe<RevenueReportInput>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryRevenueReportClassofBusinessArgs {
  args: InputMaybe<RevenueReportInput>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryUserArgs {
  email: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryUsersArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<Scalars['Int']['input']>;
}


/** Indicates what fields are available at the top level of a query operation. */
export interface QueryViewClaimAttachmentArgs {
  attachment_id: Scalars['ID']['input'];
  include_content?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum RangeType {
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export interface RefreshTokenInput {
  refresh_token: InputMaybe<Scalars['String']['input']>;
}

export interface RefreshTokenPayload {
  __typename?: 'RefreshTokenPayload';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
  refresh_token: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
}

export interface RegisterInput {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
}

export interface RegisterResponse {
  __typename?: 'RegisterResponse';
  status: RegisterStatuses;
  tokens: Maybe<AuthPayload>;
}

export enum RegisterStatuses {
  MustVerifyEmail = 'MUST_VERIFY_EMAIL',
  Success = 'SUCCESS'
}

export interface Reinsurer {
  __typename?: 'Reinsurer';
  re_company_email: Maybe<Scalars['String']['output']>;
  re_company_name: Maybe<Scalars['String']['output']>;
  re_company_website: Maybe<Scalars['String']['output']>;
  reinsurer_address: Maybe<Reinsurer_Address>;
  reinsurer_id: Maybe<Scalars['ID']['output']>;
}

export interface ReinsurerAverageOfferAcceptanceRate {
  __typename?: 'ReinsurerAverageOfferAcceptanceRate';
  average_acceptance_time: Maybe<Scalars['String']['output']>;
  fast_time: Maybe<Scalars['String']['output']>;
  period: Maybe<Scalars['String']['output']>;
  slowest_time: Maybe<Scalars['String']['output']>;
  time_change: Maybe<Scalars['Float']['output']>;
  total_offers: Maybe<Scalars['Int']['output']>;
}

export interface Reinsurer_Address {
  __typename?: 'Reinsurer_address';
  country: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
}

export interface Reinsurer_Representative {
  __typename?: 'Reinsurer_representative';
  auth_config: Maybe<AuthConfig>;
  export_iriskre_id: Maybe<Scalars['ID']['output']>;
  export_kek_id: Maybe<Scalars['ID']['output']>;
  export_visalre_id: Maybe<Scalars['ID']['output']>;
  position: Maybe<Scalars['String']['output']>;
  reinsurer: Maybe<Reinsurer>;
  rep_email: Maybe<Scalars['String']['output']>;
  rep_first_name: Maybe<Scalars['String']['output']>;
  rep_last_name: Maybe<Scalars['String']['output']>;
  rep_primary_phonenumber: Maybe<Scalars['String']['output']>;
  rep_secondary_phonenumber: Maybe<Scalars['String']['output']>;
}

export interface ReinsurersParticipation {
  __typename?: 'ReinsurersParticipation';
  offer_participant_percentage: Maybe<Scalars['Float']['output']>;
  offer_published_participant_id: Maybe<Scalars['ID']['output']>;
  participation_status: Maybe<Scalars['String']['output']>;
  transaction_thread: Maybe<Array<Maybe<TransactionThread>>>;
}

export interface ReportInput {
  brokers: InputMaybe<Array<InputMaybe<BrokerTypes>>>;
  from: InputMaybe<Scalars['String']['input']>;
  to: InputMaybe<Scalars['String']['input']>;
}

export enum ReportType {
  All = 'All',
  Outstanding = 'Outstanding',
  Paid = 'Paid'
}

export interface ResetPasswordInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface ResetPasswordResponse {
  __typename?: 'ResetPasswordResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
}

export interface RevenueByClassOfBusinessResponse {
  __typename?: 'RevenueByClassOfBusinessResponse';
  class_of_business: Scalars['String']['output'];
  iriskre: Scalars['String']['output'];
  kekre: Scalars['String']['output'];
  visalre: Scalars['String']['output'];
}

export interface RevenueData {
  __typename?: 'RevenueData';
  month: Scalars['String']['output'];
  total: Scalars['String']['output'];
}

export interface RevenueReport {
  __typename?: 'RevenueReport';
  data: Maybe<Array<Maybe<RevenueReportData>>>;
  error: Maybe<ErrorMsg>;
  name: Maybe<Scalars['String']['output']>;
}

export interface RevenueReportData {
  __typename?: 'RevenueReportData';
  cedant: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  fac_premium: Maybe<Scalars['String']['output']>;
  insured: Maybe<Scalars['String']['output']>;
  participating_percentage: Maybe<Scalars['Float']['output']>;
  payment_status: Maybe<Scalars['String']['output']>;
  period_from: Maybe<Scalars['String']['output']>;
  period_to: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  share_amount: Maybe<Scalars['String']['output']>;
}

export interface RevenueReportInput {
  currency: Scalars['String']['input'];
  from: Scalars['String']['input'];
  rangeType: RangeType;
  re_company_name: Scalars['String']['input'];
  reportType: ReportType;
  to: Scalars['String']['input'];
}

export interface RevenueReportPayload {
  __typename?: 'RevenueReportPayload';
  iriskre: Scalars['String']['output'];
  kekre: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visalre: Scalars['String']['output'];
}

export interface SendMessageOnOffer {
  message: InputMaybe<Scalars['String']['input']>;
  offer_id: InputMaybe<Scalars['ID']['input']>;
  published_by: InputMaybe<Scalars['String']['input']>;
  reinsurer_id: InputMaybe<Scalars['ID']['input']>;
  reinsurer_representative_id: InputMaybe<Scalars['ID']['input']>;
}

export interface SendOfferParticipationMessage {
  message: InputMaybe<Scalars['String']['input']>;
  offer_published_id: Scalars['ID']['input'];
  offer_published_participant: InputMaybe<Scalars['ID']['input']>;
  policy_number: Scalars['String']['input'];
  published_by: InputMaybe<Scalars['String']['input']>;
}

/** Information about pagination using a simple paginator. */
export interface SimplePaginatorInfo {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
}

export interface SocialLoginInput {
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum TermsOfService {
  Accepted = 'ACCEPTED',
  Notaccepted = 'NOTACCEPTED'
}

export interface TermsOfServiceInput {
  terms_of_service: InputMaybe<TermsOfServiceStatus>;
  user_id: InputMaybe<Scalars['ID']['input']>;
}

export enum TermsOfServiceStatus {
  Accepted = 'ACCEPTED',
  Notaccepted = 'NOTACCEPTED'
}

export interface TransactionThread {
  __typename?: 'TransactionThread';
  is_condition: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['String']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export interface TreatyPaginatedResponse {
  __typename?: 'TreatyPaginatedResponse';
  current_page: Maybe<Scalars['Int']['output']>;
  data: Maybe<Array<Maybe<TreatyResponseData>>>;
  first_page_url: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['Int']['output']>;
  last_page: Maybe<Scalars['Int']['output']>;
  last_page_url: Maybe<Scalars['String']['output']>;
  next_page_url: Maybe<Scalars['String']['output']>;
  per_page: Maybe<Scalars['Int']['output']>;
  to: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
}

export type TreatyResponse = ErrorResponse | MockTreatyStruct;

export interface TreatyResponseData {
  __typename?: 'TreatyResponseData';
  treaty: Maybe<MockTreatyStruct>;
  treaty_participation_id: Maybe<Scalars['ID']['output']>;
  treaty_participation_percentage: Maybe<Scalars['Float']['output']>;
}

export interface UnreadMessages {
  __typename?: 'UnreadMessages';
  id: Maybe<Scalars['ID']['output']>;
  offer_id: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['String']['output']>;
}

export interface UnreadTransaction {
  __typename?: 'UnreadTransaction';
  message: Maybe<Scalars['String']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['String']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
}

export interface UnreadTransactionThread {
  __typename?: 'UnreadTransactionThread';
  created_at: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  offer: Maybe<Offer>;
  offer_published_participant: Maybe<OffersParticipation>;
  offer_published_participant_id: Maybe<Scalars['ID']['output']>;
  receivable: Maybe<Reinsurer_Representative>;
  receiver_type: Maybe<Scalars['String']['output']>;
  sender_name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
}

export interface UpdateOfferParticipationPercentage {
  offer_participation_percentage: InputMaybe<Scalars['Float']['input']>;
  offer_published_id: Scalars['ID']['input'];
  offer_published_participant: Scalars['ID']['input'];
  policy_number: Scalars['String']['input'];
  published_by: InputMaybe<Scalars['String']['input']>;
}

export interface UpdatePassword {
  old_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
}

export interface UpdatePasswordResponse {
  __typename?: 'UpdatePasswordResponse';
  message: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface User {
  __typename?: 'User';
  clientActivities: Maybe<Array<Maybe<ClientActivity>>>;
  clientable: Maybe<Clientable>;
  email: Scalars['String']['output'];
  first_time_login: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  terms_of_service: Maybe<TermsOfService>;
}

export interface UserActivities {
  __typename?: 'UserActivities';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  country_code: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  device_type: Maybe<Scalars['String']['output']>;
  ip_address: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
}

/** A paginated list of User items. */
export interface UserPaginator {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
}

export interface VerifyEmailInput {
  token: Scalars['String']['input'];
}

export interface ViewAttachmentResponse {
  __typename?: 'ViewAttachmentResponse';
  content: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  download_url: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
  file_size: Maybe<Scalars['Int']['output']>;
  file_url: Scalars['String']['output'];
}

export interface WithdrawOfferParticipation {
  offer_published_id: Scalars['ID']['input'];
  offer_published_participant: Scalars['ID']['input'];
  policy_number: Scalars['String']['input'];
  published_by: InputMaybe<Scalars['String']['input']>;
}

export type Clientable = Insurer_Associate | Reinsurer_Representative;

export enum Status_Type {
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED'
}
